import React from "react";
import { CashierBrandLogo } from "./CashierBrandLogo";
import { buildCashierVisualStyle } from "./cashierVisualStyle";
import "./CashierStyle.css";

export const CashierLoadingView: React.FC = () => (
  <div className="cashier-shell cashier-status-page" style={buildCashierVisualStyle()}>
    <div className="cashier-status-card" aria-busy="true" aria-live="polite">
      <header className="cashier-status-header">
        <CashierBrandLogo size={32} className="cashier-brand-logo" />
        <span className="cashier-status-brand">安全收银台</span>
      </header>

      <div className="cashier-status-spinner" aria-hidden />

      <p className="cashier-status-loading-text">加载中…</p>
    </div>
  </div>
);
